var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.editor === 'ckeditor')?_c('ckeditor',{attrs:{"config":_vm.editorConfig},on:{"blur":function($event){return _vm.$emit('blur', _vm.data)},"input":function($event){return _vm.$emit('change', _vm.data)}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }